<script>
  import moment from 'moment'
  import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'
  import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'

  export default {
    nome: 'resultado-geracao-lotes-leilao',
    props: {
      quantidadeDeGrvsSelecionadas: {
        type: Number,
        default: () => 0,
        required: true
      },
      lotesNaoGerados: {
        type: Array,
        default: () => [],
        required: true
      }
    },
    components: {
      PopupViewer,
      HistoricoLeiloesGrv: () => import('../../../website/leiloes/components/HistoricoLeiloesGrv')
    },
    data () {
      return {
        isLoaded: false,
        showHistoricoLeiloes: false,
        grvSelecionadaParaVerificarHistoricoDeLeiloes: null
      }
    },
    computed: {
      total () {
        return this.quantidadeDeGrvsSelecionadas
      },
      quantidadeLotesGerados () {
        if (!this.total && this.total < this.lotesNaoGerados.length) return 0
        return (this.total - this.lotesNaoGerados.length)
      },
      porcentagemEfetividade () {
        const valor = +((this.quantidadeLotesGerados / this.total) * 100).toFixed(2)
        return {
          valor,
          class: valor === 100 ? 'text-success' : 'text-danger'
        }
      },
      semResultado () {
        return this.total === 0 && this.quantidadeLotesGerados === 0 && !this.lotesNaoGerados.length
      },
      Status () {
        return Status
      }
    },
    filters: {
      formatarData (date) {
        return moment(date).format('DD/MM/YYYY LTS')
      }
    },
    mounted () {
      this.isLoaded = true
    },
    methods: {
      openHistoricoLeiloesViewer ({id}) {
        this.grvSelecionadaParaVerificarHistoricoDeLeiloes = id
        this.showHistoricoLeiloes = true
      },
      closeHistoricoLeiloesViewer () {
        this.grvSelecionadaParaVerificarHistoricoDeLeiloes = null
        this.showHistoricoLeiloes = false
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Resultado da geração de lotes</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel">
          <div class="panel-body">
            <div class="resultado-estatísticas-geracao m-b-lg" v-if="!semResultado">
              <div>Total de GRVs: <span>{{total}}</span></div>
              <div>Lotes criados: <span>{{quantidadeLotesGerados}}</span></div>
              <div>Lotes não gerados: <span>{{lotesNaoGerados.length}}</span></div>
              <div>Efetividade: <span :class="porcentagemEfetividade.class">{{porcentagemEfetividade.valor}}%</span></div>
            </div>
            <div>
              <div class="text-dark resultado-success m-t-xl" v-if="semResultado">
                <i class="fa fa-warning fa-5x"></i>
                <span>Leilão não foi gerado via preparação de leilão!</span>
              </div>
              <div class="text-success resultado-success m-t-xl" v-else-if="porcentagemEfetividade.valor === 100">
                <i class="fa fa-check-circle fa-5x"></i>
                <span>Todos os lotes foram gerados com sucesso!</span>
              </div>
              <table class="table-lotes-leilao table table-clicked table-striped bg-whit b-a" v-else>
                <thead>
                <tr>
                  <th class="text-nowrap">GRV</th>
                  <th class="text-nowrap">DATA</th>
                  <th class="text-nowrap">MOTIVO</th>
                  <th class="text-nowrap">Histórico de leilões</th>
                </tr>
                </thead>
                <tbody>
                <tr class="leilao-list-lote-item" v-for="item in lotesNaoGerados">
                  <td>{{item.grv.numero}}</td>
                  <td>{{item.data.date | formatarData}}</td>
                  <td>{{item.motivo}}</td>
                  <td>
                    <ul>
<!--                      <li v-for="leilao in item.historicoLeiloes">{{leilao.tituloLeilao}} - Lote #{{leilao.numeroLote || '-'}} ({{Status.StatusTitle(leilao.statusLote)}})</li>-->
                      <button class="btn btn-success btn-xs" @click="openHistoricoLeiloesViewer(item.grv)">
                        <i class="fa fa-search"></i> Histórico de leilões</button>

                    </ul>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <popup-viewer @close="closeHistoricoLeiloesViewer" v-if="showHistoricoLeiloes">
        <HistoricoLeiloesGrv :grvId="grvSelecionadaParaVerificarHistoricoDeLeiloes" />
      </popup-viewer>
    </div>
  </transition>
</template>

<style scoped>
  .resultado-estatísticas-geracao {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
  .resultado-estatísticas-geracao span {
    font-weight: bold;
  }
  .resultado-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
</style>



// WEBPACK FOOTER //
// ResultadoGeracaoLotesLeilao.vue?2bb21286